<template>
  <!--  门店装修详情-->
  <div class="advanced-form">

    <a-form layout="vertical">
      <div class="card">
        <div class="card-head">
          <h3>门店信息</h3>
        </div>
        <div class="card-body">
          <a-row
            type="flex"
            justify="space-between"
            style="margin-bottom: 50px"
          >
            <div class="card-box">
              <div style="margin-bottom: 10px">门店名称:</div>
              <div>{{data.shopName}}</div>
            </div>
            <div class="card-box">
              <div style="margin-bottom: 10px">主营类目:</div>
              <div>{{data.categoryName}}</div>
            </div>
            <div class="card-box">
              <div style="margin-bottom: 10px">入驻类型:</div>
              <div>{{data.applyTypeDesc}}</div>
            </div>
          </a-row>
          <a-row
            type="flex"
            justify="space-between"
            style="margin-bottom: 50px"
          >
            <div class="card-box">
              <div style="margin-bottom: 10px">店铺类型:</div>
              <div>{{data.shopTypeDesc}}</div>
            </div>
            <div class="card-box">
              <div style="margin-bottom: 10px">所在地区:</div>
              <div>{{data.areaName}}</div>
            </div>
            <div class="card-box">
              <div style="margin-bottom: 10px">详细地址:</div>
              <div>{{data.address}}</div>
            </div>

          </a-row>
          <a-row
            type="flex"
            style="margin-bottom: 50px"
            justify="space-between"
          >
            <div class="card-box">
              <div style="margin-bottom: 10px">所属商圈:</div>
              <div>{{data.bizAreaName}}</div>
            </div>
            <div class="card-box">
              <div style="margin-bottom: 10px">营业电话:</div>
              <div>{{data.telephone}}</div>
            </div>
            <div class="card-box">
              <div style="margin-bottom: 10px">门店位置:</div>
              <div class="amap-box" id="container" @click="showMap"></div>
            </div>
          </a-row>
        </div>
      </div>
    </a-form>
    <a-modal
      title="查看"
      :visible="visible"
      @cancel="visible = false"
      :footer="null"
      :maskClosable="true"
      :keyboard="true"
      destroyOnClose
      centered
      :width="800"
    >
      <div class="model-img"><img :src="img" alt="" /></div>
    </a-modal>

    <div class="card" v-if="this.mPhoto">
      <div class="card-head">
        <h3>门头照片</h3>
      </div>
      <div class="card-body">
        <a-row type="flex" justify="space-between">
          <div class="card-box">
            <div class="img-box" v-for="el of this.mPhoto">
              <img :src="el" alt="" @click="openImg(el)" />
            </div>
          </div>
        </a-row>
      </div>
    </div>

    <div class="card"  v-if="this.wPhoto">
      <div class="card-head">
        <h3>外显小图</h3>
      </div>
      <div class="card-body">
        <a-row type="flex" justify="space-between">
          <div class="card-box">
            <div class="img-box" v-for="el of this.wPhoto">
              <img :src="el" alt="" @click="openImg(el)" />
            </div>
          </div>
        </a-row>
      </div>
    </div>

    <div class="card" v-if="this.gInfo.length>0">
      <div class="card-head">
        <h3>官方相册</h3>
      </div>
      <div class="card-body">
        <a-tabs :default-active-key="0" >
          <a-tab-pane  :tab="item.albumTypeDesc" v-for="(item, index) of gInfo" :key="index">
            <a-row type="flex" justify="space-between">
              <div>
                <div class="img-box" v-for="(p,pindex) of item.photos" :key="pindex">
                  <img :src="p" alt="" @click="openImg(p)" />
                </div>
              </div>
            </a-row>
          </a-tab-pane>
        </a-tabs>
      </div>
    </div>
    <div v-hasPermi="['community:localDecorVerify:check']">
      <approval-model :id = 'id' :option = 'modelOption' @pass = "pass" @reject = "reject" v-if="showBanner"></approval-model>
    </div>
    <map-model ref='mapModel'></map-model>
  </div>
</template>

<script>
import ApprovalModel from './approvalModel.vue';
import { empty } from 'ant-design-vue-admin-x';
import mapModel from '../component/mapModel.vue';
export default {
  components: {ApprovalModel, mapModel},
  data () {
    return {
      gInfo: undefined,
      modelOption: undefined,
      wPhoto: undefined,
      mPhoto: undefined,
      showBanner: false,
      id: undefined,
      img: undefined,
      position: '',
      visible: false,
      data: []
    };
  },
  beforeCreate () {
    this.form = this.$form.createForm(this);
  },
  beforeRouteEnter (to, from, next) {
    next();
    setTimeout(() => {
      document.getElementsByClassName('layout-nav')[0].style['z-index'] = '161';
      document.getElementsByClassName('layout-aside')[0].style['z-index'] = '200';
      document.getElementsByClassName('layout-content')[0].style.backgroundColor = 'transparent';
      document.getElementsByClassName('layout-content')[0].style.padding = '0px';
    }, 0);
  },
  beforeRouteLeave (to, from, next) {
    document.getElementsByClassName('layout-content')[0].style.backgroundColor =
      '#fff';
    document.getElementsByClassName('layout-content')[0].style.padding = '16px';
    next();
  },
  created () {
    if (this.$route.query.id) {
      this.getDetail(this.$route.query.id);
      this.id = this.$route.query.id;
    }
    if (this.$route.query.status == 0) {
      this.showBanner = true;
    } else {
      this.showBanner = false;
    }
  },
  methods: {
    showMap () {
      this.$refs.mapModel.show(this.data.mapLng, this.data.mapLat);
    },
    pass (val) {
      this.toExamine(1, val);
    },
    reject (val, modelOption) {
      this.toExamine(2, val, modelOption);
    },
    toExamine (type, modalValue, modelOption) {
      //  1待审核2已驳回3已通过
      this.$post({
        url: '/local/decor/verify/check',
        params: {
          verifyId: this.id,
          status: type, // 1：通过，2：拒绝
          remark: modalValue, // 审核备注
          refuseIds: modelOption?.toString()
        }
      }).then((res) => {
        this.$message[type == 1 ? 'success' : 'error'](type == 1 ? '审核通过' : '审核已驳回');
        empty.$emit('update_storeDecoration');
        this.$router.go(-1);
      });
    },
    openImg (img) {
      this.visible = true;
      this.img = img || '';
    },
    getDetail (id) {
      this.$get({
        url: '/local/decor/verify/' + id,
        params: {}
      }).then(({data}) => {
        this.data = data;
        let mInfo = data.verifyInfo.filter(i => i.modelType == 1);
        let wInfo = data.verifyInfo.filter(i => i.modelType == 2);

        let OptionArr = data.verifyInfo.map((item) => {
          return {id: item.infoId, label: item.modelTypeDesc};
        });
        let map = new Map();
		    for (let item of OptionArr) {
		        if (!map.has(item.label)) {
		            map.set(item.id, item);
		        }
		    }
		    this.modelOption = [...map.values()];

        this.wPhoto = wInfo && wInfo[0]?.photos;
        this.gInfo = data.verifyInfo.filter(i => i.modelType == 3);

        this.wPhoto = wInfo && wInfo[0]?.photos;
        this.mPhoto = mInfo && mInfo[0]?.photos;

        this.initAMap();
      });
    },
    initAMap () {
      this.$nextTick(() => {
        AMapUI.loadUI(['misc/PositionPicker'], (PositionPicker) => {
          this.map = new AMap.Map('container', {
            resizeEnable: true,
            scrollWheel: true
          });
          this.map.setZoomAndCenter(15, [this.data.mapLng, this.data.mapLat]);

          let marker = new AMap.Marker({
            position: new AMap.LngLat(this.data.mapLng, this.data.mapLat),
            anchor: 'bottom-center',
            offset: new AMap.Pixel(0, 0)
          });
          this.map.add(marker);
        });
      });
    }
  }
};
</script>

<style scoped>
.amap-box {
  width: 220px;
  height: 100px;
}
.img-box {
  height: 100px;
  display: inline-block;
  margin: 0 10px 10px 0;
}
.img-box img {
  width: 100px;
  height: 100%;
  object-fit: contain;
  background: #ededed;
}
.model-img img {
  width: auto;
  height: auto;
  max-width: 100%;
  max-height: 800px;
  padding: 5px;
  margin:0 auto;
  display: block;
}
.card-box{
  font-size: 14px;
  width: 33.33333333%;
  word-break: break-all;
}

</style>
